import React from 'react';
import { useWeb3React } from '@web3-react/core';
import Image from "next/legacy/image";
import Link from 'next/link';
import useRaffles from '../hooks/useRaffles';
import RaffleStatusBadge from './RaffleStatusBadge';
import AuctionStatusBadge from './AuctionStatusBadge';

const formatDate = (date) =>
  date.toLocaleString('en-US', {
    dateStyle: 'medium',
    timeStyle: 'short',
  });

const RaffleCard = ({ raffleKey }) => {
  const raffle = useRaffles(raffleKey);
  const { active } = useWeb3React();

  const raffleStart = new Date(raffle.start_time);

  return (
    <div className="p-4">
      <h2 className="fs-2 title mb-1">{raffle.title}</h2>
      <div className="fs-5 fw-bold title mb-3 text-capitalize text-pink">
        {raffle.type === 'raffle' ? 'raffle' : 'for sale'}
      </div>
      <p className="text-muted">{formatDate(raffleStart)}</p>
      {active ? (
        <p>
          {raffle.type === 'raffle' ? (
            <RaffleStatusBadge raffleKey={raffleKey} />
          ) : (
            <AuctionStatusBadge raffleKey={raffleKey} />
          )}
        </p>
      ) : (
        ''
      )}
      <div>
        <Image
          src={raffle.image}
          width={1200}
          height={1200}
          alt={raffle.title}
          className="rounded"
          unoptimized
        />
      </div>
      <div className="my-3 text-center">
        <Link
          href={`/shop/${raffleKey}`}
          passHref
          className="btn btn-lg btn-dark rounded-pill px-4 w-100 stretched-link">
          
            More info
          
        </Link>
      </div>
    </div>
  );
};

export default RaffleCard;
